import { render } from "./ConfirmRegisterPCPRetailer.vue?vue&type=template&id=6c2a4ac8"
import script from "./ConfirmRegisterPCPRetailer.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegisterPCPRetailer.vue?vue&type=script&lang=ts"
script.render = render

export default script